<template>
  <div>
    <h1>429 Internal Server Error</h1>
  </div>
</template>

<script>
export default {
  mounted() {
  },
}
</script>
